(() => {
  function initAffiliatesPage(section) {
    if (!section || section.dataset.affiliatesInitialized === 'true') return;

    section.dataset.affiliatesInitialized = 'true';

    let activePopup = null;
    let lastFocusedElement = null;
    let affiliatesSwiper = null;

    const mobileBreakpoint = 749;

    const focusableSelector = [
      'a[href]',
      'button:not([disabled])',
      'input:not([disabled])',
      'select:not([disabled])',
      'textarea:not([disabled])',
      '[tabindex]:not([tabindex="-1"])'
    ].join(',');

    function getPopupById(popupId) {
      return section.querySelector(`[data-affiliates-popup="${popupId}"]`);
    }

    function getFocusableElements(popup) {
      return Array.from(popup.querySelectorAll(focusableSelector)).filter((element) => {
        return element.offsetParent !== null || element === document.activeElement;
      });
    }

    function openPopup(popupId, trigger) {
      const popup = getPopupById(popupId);

      if (!popup) {
        console.warn('Affiliate popup not found:', popupId);
        return;
      }

      activePopup = popup;
      lastFocusedElement = trigger || document.activeElement;

      popup.hidden = false;
      popup.setAttribute('aria-hidden', 'false');
      document.body.classList.add('AffiliatesPageModalOpen');

      setTimeout(() => {
        const firstInput = popup.querySelector('input, select, textarea');
        const closeButton = popup.querySelector('[data-affiliates-popup-close]');

        if (firstInput) {
          firstInput.focus();
        } else if (closeButton) {
          closeButton.focus();
        }
      }, 100);
    }

    function closePopup() {
      if (!activePopup) return;

      activePopup.hidden = true;
      activePopup.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('AffiliatesPageModalOpen');

      if (lastFocusedElement && typeof lastFocusedElement.focus === 'function') {
        lastFocusedElement.focus();
      }

      activePopup = null;
      lastFocusedElement = null;
    }

    function trapFocus(event) {
      if (!activePopup || event.key !== 'Tab') return;

      const focusableElements = getFocusableElements(activePopup);
      if (!focusableElements.length) return;

      const firstElement = focusableElements[0];
      const lastElement = focusableElements[focusableElements.length - 1];

      if (event.shiftKey && document.activeElement === firstElement) {
        event.preventDefault();
        lastElement.focus();
      }

      if (!event.shiftKey && document.activeElement === lastElement) {
        event.preventDefault();
        firstElement.focus();
      }
    }

    section.addEventListener('click', (event) => {
      const trigger = event.target.closest('[data-affiliates-popup-open]');
      const closeTrigger = event.target.closest('[data-affiliates-popup-close]');

      if (trigger) {
        event.preventDefault();
        event.stopPropagation();

        openPopup(trigger.dataset.affiliatesPopupOpen, trigger);
        return;
      }

      if (closeTrigger) {
        event.preventDefault();
        closePopup();
      }
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') {
        closePopup();
      }

      trapFocus(event);
    });

    function formatNumber(number) {
      return String(number).padStart(2, '0');
    }

    function updatePagination(swiper) {
      const paginationEl = section.querySelector('[data-affiliates-mobile-pagination]');
      if (!paginationEl) return;

      const currentEl = paginationEl.querySelector('.AffiliatesPage__paginationCurrent');
      const totalEl = paginationEl.querySelector('.AffiliatesPage__paginationTotal');
      const lineEl = paginationEl.querySelector('.AffiliatesPage__paginationLine');

      const total = swiper.slides.length;
      const current = swiper.realIndex + 1;
      const progress = total > 1 ? (current / total) * 100 : 100;

      if (currentEl) currentEl.textContent = formatNumber(current);
      if (totalEl) totalEl.textContent = formatNumber(total);
      if (lineEl) lineEl.style.setProperty('--affiliate-progress', progress + '%');
    }

    function initMobileSwiper() {
      const swiperEl = section.querySelector('[data-affiliates-mobile-swiper]');
      if (!swiperEl) return;

      if (window.innerWidth > mobileBreakpoint) {
        if (affiliatesSwiper) {
          affiliatesSwiper.destroy(true, true);
          affiliatesSwiper = null;
        }
        return;
      }

      if (affiliatesSwiper) return;

      if (typeof Swiper === 'undefined') {
        console.warn('Swiper is not loaded.');
        return;
      }

      affiliatesSwiper = new Swiper(swiperEl, {
        slidesPerView: 'auto',
        spaceBetween: 10,
        speed: 600,
        loop: false,
        grabCursor: true,
        watchOverflow: true,
        on: {
          init() {
            updatePagination(this);
          },
          slideChange() {
            updatePagination(this);
          },
          resize() {
            updatePagination(this);
          }
        }
      });
    }

    initMobileSwiper();

    window.addEventListener('resize', initMobileSwiper);

    document.addEventListener('shopify:section:unload', (event) => {
      if (event.target === section) {
        document.body.classList.remove('AffiliatesPageModalOpen');

        if (affiliatesSwiper) {
          affiliatesSwiper.destroy(true, true);
          affiliatesSwiper = null;
        }
      }
    });
  }

  function initAllAffiliatesPages(root = document) {
    const sections = root.querySelectorAll('[data-affiliates-section]');
    sections.forEach(initAffiliatesPage);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      initAllAffiliatesPages();
    });
  } else {
    initAllAffiliatesPages();
  }

  document.addEventListener('shopify:section:load', (event) => {
    initAllAffiliatesPages(event.target);
  });
})();